module.exports = __webpack_public_path__ + "img/card-3a-report.4f8f2f76.svg";